import { NgModule } from '@angular/core'
import { DropdownModule } from 'primeng/dropdown';
import { CarouselModule } from 'primeng/carousel';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuModule } from 'primeng/menu';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { MessagesModule } from 'primeng/messages';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SliderModule } from 'primeng/slider';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { SidebarModule } from 'primeng/sidebar';
import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';

const MODULES_IMPORTS = [
  DropdownModule,
  CarouselModule,
  MultiSelectModule,
  MenuModule,
  TagModule,
  DialogModule,
  TabViewModule,
  MessagesModule,
  CheckboxModule,
  TooltipModule,
  ToastModule,
  InputSwitchModule,
  ProgressSpinnerModule,
  SliderModule,
  ButtonModule,
  FileUploadModule,
  SidebarModule,
  ProgressBarModule,
  SkeletonModule,
  TableModule
]


@NgModule({
  imports: [

    ...MODULES_IMPORTS
  ],
  exports: [
    ...MODULES_IMPORTS
  ],
  declarations: []
})
export class PrimeMaterialModule { }
